<template>
  <article>
    <!-- fido fingerprint 등록 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <action-sheet
      class="action-sheet"
      :opened.sync="$store.state.auth.createFido.isFidoActionSheetOpen"
      :title="$t($store.state.auth.createFido.fidoActionSheetTitle)"
      :actionHeader="true"
      :actionFooter="false"
      :useTopBorder="true"
      :noDimClose="true"
      @cancel="FN001"
    >
      <template #content>
        <!-- {{ getFidoRegInfo.out }} -->
        <div
          class="access-method"
          :class="{ error: $store.state.auth.createFido.isFidoActionSheetError }"
        >
          <i v-if="$store.state.native.biometryTypeIos === 'faceId'" class="icon icon-face" />
          <i v-else class="icon icon-fingerprint" />
        </div>
        <div class="access-method-info">
          <p v-html="$t($store.state.auth.createFido.fidoActionSheetContent)"></p>
        </div>
      </template>
    </action-sheet>
    <!-- fido fingerprint 등록 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->

    <!-- 알림 팝업 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <modal-pop
      :opened.sync="$store.state.auth.createFido.isFidoPopOpen"
      :noPostivieButton="true"
      :noDimClose="true"
      :modalFooter="true"
      :title="$store.state.auth.createFido.fidoPopTitle"
      @confirm="$store.state.auth.createFido.fidoPopConfirm"
      class="modal"
    >
      <template #content>
        <p v-html="$t($store.state.auth.createFido.fidoPopMessage)"></p>
      </template>
    </modal-pop>
    <!-- 알림 팝업 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->

    <!-- 알림 actionSheet [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <action-sheet
      class="action-sheet"
      :opened.sync="$store.state.auth.manageFido.isFidoActShtOpen"
      :title="$store.state.auth.manageFido.fidoActShtTitle"
      :actionHeader="true"
      :actionFooter="true"
      :useTopBorder="true"
      :noDimClose="true"
      :noNegativeButton="$store.state.auth.manageFido.isNegativeButton"
      :cancel="$store.state.auth.manageFido.fidoActShtCancelText"
      @cancel="$store.state.auth.manageFido.fidoActShtCancelFunction"
      :noPositiveButton="$store.state.auth.manageFido.isPositiveButton"
      :confirm="$store.state.auth.manageFido.fidoActShtConfirmText"
      @confirm="$store.state.auth.manageFido.fidoActShtConfirmFunction"
    >
      <template #content>
        <strong class="info-question">
          <p
            v-if="$store.state.auth.manageFido.fidoActShtContents1 !== ''"
            v-html="$t($store.state.auth.manageFido.fidoActShtContents1)"
          ></p>
          <br v-if="$store.state.auth.manageFido.fidoActShtContents2 !== ''" />
          <p
            v-if="$store.state.auth.manageFido.fidoActShtContents2 !== ''"
            v-html="$t($store.state.auth.manageFido.fidoActShtContents2)"
          ></p>
          <br v-if="$store.state.auth.manageFido.fidoActShtContents3 !== ''" />
          <p
            v-if="$store.state.auth.manageFido.fidoActShtContents3 !== ''"
            v-html="$t($store.state.auth.manageFido.fidoActShtContents3)"
          ></p>
        </strong>
      </template>
    </action-sheet>
    <!-- 알림 actionSheet [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
  </article>
</template>
<style type="scss" scoped></style>
<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import Common from "@/components/basic/Common";

export default {
  extends: Common,
  props: {},
  created() {},
  mounted() {},
  updated() {},
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapFields(["needLoginModalOpended", "sessionInfo"]),
    ...mapGetters("auth/createFido", ["getFidoRegInfo", "getSvrFidoInfo"]),
  },
  methods: {
    FN001: function () {
      this.$bridge.fidoFingerprintCancel();
    },
  },
};
</script>
